// extracted by mini-css-extract-plugin
export default {"stage":"LinkedIn-module--stage--6c0c2","metadata":"LinkedIn-module--metadata--90bfc","title":"LinkedIn-module--title--41f5f","description":"LinkedIn-module--description--2f36b"};